//#region Libraries
import { 
    Routes, 
    Route, 
    Navigate
} from "react-router-dom";
//#endregion
//#region Components
import Form from "./Form";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import CheckAcadReinforceExistence from "../../components/CheckAcadReinforceExistence/CheckAcadReinforceExistence";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

const ManualLoadingForm = ({
    userRole
}) => {
    const loadingRequest = useLoadingRequest();
    return (
        <>
        <Preloader {...loadingRequest.value}/>
        <Routes>
            <Route 
                path="crear" 
                element={
                    <Form 
                        create 
                        loadingRequest={loadingRequest}/>}/>
            <Route path="editar" 
                element={
                    <CheckAcadReinforceExistence 
                        loadingRequest={loadingRequest}
                        defaultPath={ABSOLUTE_PATHS.CREATE_ACAD_REINFORCE_MANUAL_LOADING}>
                        <Form loadingRequest={loadingRequest}/>
                    </CheckAcadReinforceExistence>
                }/>
            <Route 
                path="*" 
                element={
                    <Navigate 
                        to={ABSOLUTE_PATHS.CREATE_ACAD_REINFORCE_MANUAL_LOADING}
                        replace/>}/>
        </Routes>
        </>
    );
}

export default ManualLoadingForm;